export default function (form) {
	return `
		${this.render(
			'form/form',
			form,
			'account/changePassword',
			['form--changePassword'],
			{}
		)}
	`;
}
